module.exports = __webpack_public_path__ + "img/bca_va.bef9162d.svg";